module.exports = __webpack_public_path__ + "img/result-detail-invest-inleft02.70816302.svg";